import ReactGA from 'react-ga4';
import config from "./utils/config";

ReactGA.initialize(config.ga, {testMode: config.env !== 'production'})
